var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCambridgeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7734 11.8516V23.4526C35.7734 24.0681 36.2715 24.5659 36.8867 24.5659C37.5019 24.5659 38 24.0681 38 23.4526V11.0166L35.7734 11.8516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64542 26.9088C3.59613 26.8952 3.54771 26.9051 3.49843 26.8984C3.4445 26.8903 3.39609 26.8662 3.33984 26.8662C3.30882 26.8662 3.28041 26.8795 3.24939 26.8807C3.21518 26.8836 3.18329 26.8903 3.14937 26.8964C1.34377 27.0538 0 29.3688 0 32.4326C0 35.4895 1.33739 37.7996 3.1369 37.9671C3.17778 37.975 3.21663 37.9828 3.25867 37.9863C3.2865 37.9874 3.31172 37.999 3.33984 37.999C3.39406 37.999 3.44016 37.9758 3.49205 37.9683C3.54337 37.9613 3.59439 37.9712 3.64542 37.9567C7.85501 36.7538 12.2391 36.0676 16.5647 35.8818C15.9994 34.9505 15.6602 33.7761 15.6602 32.4326C15.6602 31.0891 15.9994 29.915 16.565 28.9835C12.2394 28.7976 7.85501 28.1117 3.64542 26.9088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.54 29.0078C20.4087 29.0623 20.2646 29.0936 20.1133 29.0936C18.8229 29.0936 17.8867 30.4982 17.8867 32.4334C17.8867 34.3686 18.8229 35.7733 20.1133 35.7733C20.2643 35.7733 20.4078 35.8046 20.5392 35.8591C23.6932 35.9495 26.9162 36.2968 30.0273 36.9225C29.433 35.6773 29.0938 34.146 29.0938 32.4334C29.0938 30.7206 29.4332 29.1895 30.0273 27.9443C26.9168 28.57 23.6938 28.9173 20.54 29.0078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6602 26.8662C32.7566 26.8662 31.3203 29.2592 31.3203 32.4326C31.3203 35.6063 32.7566 37.999 34.6602 37.999C36.5638 37.999 38 35.6063 38 32.4326C38 29.2592 36.5638 26.8662 34.6602 26.8662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.721893 8.90922L18.6086 15.5889C18.7347 15.6359 18.8675 15.6596 19 15.6596C19.1325 15.6596 19.2653 15.6359 19.3914 15.5889L37.0897 8.97996H19C18.3848 8.97996 17.8867 8.48217 17.8867 7.86668C17.8867 7.25148 18.3848 6.7534 19 6.7534H37.0897L19.3914 0.0702323C19.1392 -0.0234108 18.8608 -0.0234108 18.6086 0.0702323L0.721893 6.82414C0.288177 6.98736 0 7.40252 0 7.86668C0 8.33084 0.288177 8.74629 0.721893 8.90922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2461 13.5215L19.3914 17.9668C19.2653 18.0135 19.1325 18.0372 19 18.0372C18.8675 18.0372 18.7347 18.0135 18.6086 17.9668L6.75391 13.5215V16.7729C6.75391 20.389 13.0628 22.3393 19 22.3393C24.9372 22.3393 31.2461 20.389 31.2461 16.7729V13.5215Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_3792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCambridgeicon);
export default __webpack_public_path__ + "static/media/Cambridge icon.a0693f0d5842c44910a7c3578d3e24d1.svg";
export { ForwardRef as ReactComponent };